<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #000;
  opacity: .3;
}

.modal-alert {
  position: fixed;
  width: 900px;
  background: #fff;
  z-index: 9;
  left: 50%;
  top: 50%;
  margin-left: -450px;
  transform: translateY(-50%);
  padding-bottom: 20px;
}

.title-close {
  height: 50px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  font-size: 18px;
  color: #212121;
}
.title-close div{
  height: 100%;
  line-height: 50px;
}

.modal-alert .btns {
  width: 60px;
  height: 28px;
  background: #4FA1A4;
  border-radius: 2px;
  color: #fff;
  margin-top: 10px;
  float: right;
  margin-right: 20px;
  line-height: 28px;
  cursor: pointer;
  font-size: 14px;
}

.modal-alert .close {
  cursor: pointer;
  color: #909399;
}

.modal-alert .close:hover {
  color: #409EFF;
}

.modal-alert .tips {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 4px;
  margin: 15px;
  text-align: left;
  padding: 10px 20px;
  line-height: 25px;

}

.modal-alert .sub-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.modal-alert .sub-title span {
  background: #4FA1A4;
  width: 4px;
  height: 16px;
  display: inline-block;
  margin-right: 8px;
}

.person-search {
  display: flex;
  padding-left: 30px;
  padding-top: 10px;
  align-items: center;
  color: #666;
}

.person-search .item1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.person-search .item1 .label {
  margin-right: 10px;
  word-break: keep-all;
}

.person-search .select-wrap {
  width: 250px;
}

/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 8px 0;
  color: #323233;
}

/deep/ .el-table td {
  padding: 8px 0px;
}
/deep/.el-input-number__decrease{
  height: 33px; 
  top:3px
}
/deep/ .el-input-number__increase{
  height: 33px; 
  top:3px
}

.table-wrap {
  margin: 20px;
  margin-top: 0;
}
.btns.cancel {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color:#666;
}


 .search{
  display:flex;
  align-items:center;
  padding-left:20px;

}
 .input{
  background:none;
  outline:none;
  border:none;
  width:200px;
  height:32px;
  margin:10px;
  border: 1px solid rgba(217,217,217,1);
  border-radius: 2px;
  padding-left: 10px;
}
 .search .btn{
  background: #4FA1A4;
  border-radius: 2px;
  color:#fff;
  width:60px;
  height:28px;
  line-height:28px;
  text-align: center;
  margin-left:10px;
  border:1px solid transparent ;
  cursor: pointer;
} 
.search .btn.gray{
  border:1px solid #D9D9D9 ;
  color:#212121;
  background: #fff;
}
.search-sum{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 14px;
}
</style>
<template>
  <div class="main" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="modal" @click="close"></div>
    <div class="modal-alert">
      <div class="title-close">
        <div class="title"  style="margin-bottom:0">人员明细</div>
        <i class="el-icon-close close" @click="close"></i>
      </div>
      <!-- <div class="tips">
        1、如果调整人员或者任务太多，请至【批量调整任务量】功能修改；<br>
        2、如果任务量改为0，则人员任务删除，无法继续执行此任务，移动端任务将不展示，请慎重修改
        总任务量：<span class="txt-color">{{detail.taskTotalType !='不限量'? taskDetail.taskTotal:'不限量' }}</span><span v-if="taskDetail.taskTotal">{{ taskDetail.taskTotalUnit }}</span>，已分解给
        <span class="txt-color">
          {{ taskDetail.taskDetailOrganisationList && taskDetail.taskDetailOrganisationList.length }}</span>个部门，<span class="txt-color">{{ taskDetail.staffTotal }}</span>个人员
        </div>
      </div> -->
      <div class="search-sum">
        <div class="sum">
          合计：共<span style="color:#4FA1A4;font-weight: bold;">{{staffTotal }}</span>人，总任务量：<span style="color:#4FA1A4;font-weight: bold;">{{ planCountTotal }}</span>
        </div>
        <div class="search">
            <div class="name">姓名</div>
            <input  class="input" v-model="page.keyword"  placeholder="请输入姓名"/>
            <div class="btn"  @click="search">搜索</div>
            <div class="btn gray" @click="emptySearch">清空</div>
        </div>
       
       </div>
      <div class="table-wrap">
        <el-table :data="detailData" max-height="500" stripe border header-cell-class-name="table_header">
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">{{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}</template>
          </el-table-column>
          <template v-if="isSjbzRow">
            <!-- 标注行形态：N7 行级拆分明细（item-page-list），列=人员/计划量/完成量/初审/复审/质检/分配时间 -->
            <el-table-column show-overflow-tooltip label="人员名称" width="120" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
            </el-table-column>
            <el-table-column label="计划量" width="90" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.planAmount }}</template>
            </el-table-column>
            <el-table-column label="已完成量" width="90" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.finishAmount }}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="初审人员" width="110" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.firstReviewStaffName || '-' }}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="复审人员" width="110" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.secondReviewStaffName || '-' }}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="质检人员" width="110" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.qcStaffName || '-' }}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="三类人员设置时间" width="170" header-align="center" align="left">
              <template slot-scope="scope">{{ formatTime(scope.row.staffAssignTime) }}</template>
            </el-table-column>
          </template>
          <template v-else>
          <el-table-column show-overflow-tooltip label="人员名称" width="140" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="部门名称" width="220" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
          </el-table-column>


          <!-- <el-table-column width="200" header-align="center" align="right" v-for="item in tableHead" :key="item.label" :label="item.label" :prop="item.label"></el-table-column> -->
          <el-table-column :label="planTitle"  header-align="center" align="left">
              <template slot-scope="scope">{{!scope.row.isNotLimit? scope.row.planCount:'不限量' }}</template>
          </el-table-column>
          <el-table-column v-if="planTitle!='任务总量'" label="实际完成量" width="120" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.realCount }}</template>
          </el-table-column>
          <el-table-column v-if="planTitle!='任务总量'" label="实际完成率(%)" width="120" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.finishRate }}</template>
          </el-table-column>
          </template>
        </el-table>
        <el-pagination style="margin-top:10px;    width: 860px" background @size-change="handleSizeChange" :pager-count="page.count"
          @current-change="handleCurrentChange" :page-sizes="[10]" :current-page="page.pageIndex"
          :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
        </el-pagination>
      </div>
      <div class="btns " @click="close">
        确定
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
    planTitle: {
      type: String,
      default: '任务总量',
    },
  },
  data() {
    return {
      fullscreenLoading:false,
      detailData:[],
      planCountTotal:0,
      staffTotal:0,
      tableHead:[],
      page: {
        count:3,
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        taskMainGuid: this.$route.query.guid,
        taskDetailGuid: '',
        keyword: '',
      }
    };
  },
  computed: {
    // 数据标注行走 N7 行级拆分明细（item-page-list），普通行维持原接口
    isSjbzRow() {
      return this.detail && this.detail.taskContentType == 'SJBZ';
    },
  },
  created() {
   // this.getStaffList();
   this.getDetailList()
  },
  methods: {
    // FOUR-3015：后端为 Timestamp 直出（形态随序列化漂移），前端统一格式化
    formatTime(val) {
      return val ? this.$moment(val).format('YYYY-MM-DD HH:mm:ss') : '-';
    },
    close() {
      this.$emit('close')
    },
    submit() {
      console.log(this.detail);
    },
    search(){
        // this.detailData = [];
        this.page.pageIndex = 1;
        this.getDetailList();
      },
      emptySearch(){
        this.page.keyword = '';
        this.page.pageIndex = 1;
        // this.detailData = [];
        this.getDetailList();

      },

    //查询明细
    getDetailList() {
      if (this.isSjbzRow) {
        this.getLabelItemList();
        return;
      }
      this.page.taskDetailGuid = this.detail.guid;
      // console.log(this.detail);
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/staff/get`, this.page).then((res) => {
        this.fullscreenLoading = true;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.fullscreenLoading = false;
          this.detailData = res.data.data.pageData.records;
          this.page.totalPage = res.data.data.pageData.totalPages;
          this.page.totalRows = res.data.data.pageData.totalRows;
          this.planCountTotal =  res.data.data.planCountTotal;
          this.staffTotal =  res.data.data.staffTotal;
          if(this.detailData&&this.detailData[0]&& this.detailData[0].goodsList){
            this.tableHead = [];
            this.detailData[0].goodsList.forEach(item=>{
              this.tableHead.push({
                label: `${item.name}(${item.goodsUnit})`,
              })
          
             // console.log(this.tableHead)
              // console.log(this.detailData)
            })
            this.detailData.forEach(i=>{
              i.goodsList.forEach(j=>{
                i[`${j.name}(${j.goodsUnit})`] = j.goodsCount;
              })
            })
            console.log(this.detailData)
          }


        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    // 标注行明细：N7 item-page-list（2026-09-21，普通行 staff/get 无拆分/三类人员数据）
    getLabelItemList() {
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/label-task/item-page-list`, {
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize,
        taskDetailGuid: this.detail.guid,
        keyword: this.page.keyword,
      }).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          const pageData = (res.data.data && res.data.data.records) || [];
          this.detailData = pageData;
          this.page.totalRows = (res.data.data && res.data.data.totalRows) || 0;
          this.staffTotal = this.page.totalRows;
          this.planCountTotal = pageData.reduce((sum, item) => sum + (item.planAmount || 0), 0);
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(() => {
        this.fullscreenLoading = false;
      });
    },
    handleSizeChange(val) {
        this.page.pageSize = val;
        this.getDetailList();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getDetailList();
    },


  },
};
</script>